module.exports = __webpack_public_path__ + "img/D.7ba1ec35.jpg";